[
  {
    "code": "FI-08",
    "name": "Central Finland"
  },
  {
    "code": "FI-07",
    "name": "Central Ostrobothnia"
  },
  {
    "code": "FI-05",
    "name": "Kainuu"
  },
  {
    "code": "FI-09",
    "name": "Kymenlaakso"
  },
  {
    "code": "FI-10",
    "name": "Lapland"
  },
  {
    "code": "FI-13",
    "name": "North Karelia"
  },
  {
    "code": "FI-14",
    "name": "Northern Ostrobothnia"
  },
  {
    "code": "FI-15",
    "name": "Northern Savonia"
  },
  {
    "code": "FI-12",
    "name": "Ostrobothnia"
  },
  {
    "code": "FI-11",
    "name": "Pirkanmaa"
  },
  {
    "code": "FI-16",
    "name": "Päijänne Tavastia"
  },
  {
    "code": "FI-17",
    "name": "Satakunta"
  },
  {
    "code": "FI-02",
    "name": "South Karelia"
  },
  {
    "code": "FI-03",
    "name": "Southern Ostrobothnia"
  },
  {
    "code": "FI-04",
    "name": "Southern Savonia"
  },
  {
    "code": "FI-19",
    "name": "Southwest Finland"
  },
  {
    "code": "FI-06",
    "name": "Tavastia Proper"
  },
  {
    "code": "FI-18",
    "name": "Uusimaa"
  },
  {
    "code": "FI-01",
    "name": "Åland"
  }
]